import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
export interface AdminUserData {
    userId: string,
    displayName: string;
    email: string;
    phoneNumber: string;
    photoUrl: string;
}

export const authService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createAdminUser: builder.mutation<string, AdminUserData>({
            query: (data) => ({
                url: `https://adminhttps-createadmin${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),

        getCheckAdminUser: builder.query({
            query: (ownerId) => ({
                url: `https://adminhttps-getadminidforuserid${API_BASE_DOMAIN}?userId=${ownerId}`,
                method: "GET",
                responseHandler: (response) => response.json(), 
            }),
        }),

        addMessageToken: builder.mutation<{ message: string }, { token: string; userType: string }>({
            query: (data) => ({
                url: `https://adminhttps-addmessagetoken${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.json(),
            }),
        }),

    }),
});

export const { useCreateAdminUserMutation, useLazyGetCheckAdminUserQuery,useAddMessageTokenMutation } = authService;
